import type { BusinessGetResponseType } from "@sellar-io/api-v2/types";

/**
 * Retailer onboarding is business-profile completeness, not session readiness.
 * Keep these requirements here so authentication and routing do not need to
 * understand which retailer fields constitute a completed account.
 */
export const isBusinessOnboardingIncomplete = (
  business: BusinessGetResponseType | null,
): boolean =>
  business?.type === "retailer" &&
  ![
    business.Retailer?.venueTypes.length,
    business.name,
    business.email,
    business.entityType,
    business.DeliveryAddress.name,
    business.InvoiceAddress.name,
  ].every(Boolean);
